/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitAppointmentsAliases {
  ACTION_CONFIRM = 'action-confirm',
  ACTION_REFUSE = 'action-refuse',
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  BREADCRUMB_ACCREDITATION = 'breadcrumb-accreditation',
  CARD_APPOINTMENTS = ' card-appointments',
  CARD_HISTORIES = 'card-histories',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_HISTORIES = 'deck-histories',
  FETCH_APPOINTMENTS = 'fetch-appointments',
  FETCH_HISTORIES = 'fetch-histories',
  FETCH_MENUS_MOBILE = 'fetch-menus-mobile',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_HISTORIES = 'field-histories',
  FIELD_MESSAGE = 'field-message',
  FIELD_REFUSAL_REASON = 'field-refusal-reason',
  FORM_DATA = 'form-data',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FORM_MESSAGE = 'form-message',
  HPMS_TEXT_HTML = 'hpms-text-html',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  MAPPER_0 = 'mapper-0',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_APPOINTMENT_DETAILS = 'panel-appointment-details',
  PANEL_CARD = 'panel-card',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_MODAL = 'panel-modal',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_6 = 'text-6',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_SUGESTED_DATES = 'text-sugested-dates',
}
export { TechnicalVisitAppointmentsAliases };
